<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
  >
    <v-card class="pt-4 pr-4 pl-4" flat max-width="500">
      <v-form ref="form" v-model="valid">
        <v-radio-group v-model="policeDetails.isRecorded">
          <v-radio :label="$t('report.policeDetails.isNotPolicy')" :value="false"></v-radio>
          <v-radio :label="$t('report.policeDetails.isPolicy')" :value="true"></v-radio>
        </v-radio-group>
        <v-text-field
          outlined
          :label="$t('report.policeDetails.department')"
          v-if="policeDetails.isRecorded"
          :rules="requiredRule"
          v-model="policeDetails.department"
        />
        <v-text-field
          outlined
          :label="$t('report.policeDetails.fileReference')"
          v-if="policeDetails.isRecorded"
          v-model="policeDetails.fileReference"
        />
      </v-form>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { requiredRule } from "@/lib/rules/requiredRule";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { MrfiktivCreatePoliceDetailsDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportPolice extends ReportStepMixin implements IReportStep {
  get header(): IReportHeaderData {
    return {
      title: this.$t("report.policeDetails.title").toString(),
      description: this.$t("report.policeDetails.description").toString()
    };
  }
  screen = ReportScreenEnum.police;

  valid = false;

  get requiredRule() {
    const rules = [];

    rules.push(requiredRule());

    return rules;
  }

  get policeDetails() {
    return ReportModule.policeDetails;
  }

  set policeDetails(details: MrfiktivCreatePoliceDetailsDtoGen) {
    ReportModule.mutatePoliceDetails(details);
  }

  get isDone() {
    return this.valid;
  }

  get color() {
    return getDefaultPartnerColor();
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
